@if (crmService.wizardLoading().isLoadingWizardStepAction) {
<zint-loader class="mx-auto" size="small" [overlay]="true" [dotColor]="'var(--zint-grey-500)'"></zint-loader>
}
@if (shouldShowTestExportModal) {
  <button class="d-block rounded-btn-base rounded-btn-vivid-outline btn-p-md mb-1 me-0 ms-auto" (click)="openTestExport()" matTooltip="with some sample companies">Perform a Test Export</button>
  
  <export-to-crm [crmName]="crmType" [randomCompanyIds]="randomIds"></export-to-crm>
}
<div class="crm-mapping-container">
  <div class="crm-table-header row g-0">
    <div class="col-3">ZINT Property</div>
    <div class="col-3">{{crmType | titlecase}} Field      
    </div>
    <div class="col-3 text-center">Overwrite?
      <small class="text-sup" role="button" matTooltip="Help" (click)="toggleOverwriteHelp()">
        <i class="fas fa-circle-info text-vivid-blue"></i>
      </small>
    </div>
    <div class="col-3 text-center">Action</div>
  </div>

 @if (selectedFieldMappings.length < 1) {
  <div class="crm-table-row row g-0 justify-content-center">
    <button class="rounded-btn-base rounded-btn-light btn-p-sm w-auto" (click)="addMappingRow()">
      <i class="fas fa-plus"></i> Add New Mapping
    </button>
  </div>
 }
  @for (mapping of selectedFieldMappings; let mapIndex = $index; track mapIndex) {
    <div class="crm-table-row row g-0">
      <div class="col-3">
        @if($first){
          <zint-autocomplete 
            [options]="zintProperties" 
            [displayProperty]="'displayName'" 
            label="ZINT Property"
            [preSelectedValue]="customZintProperty"
            (optionSelected)="getCRMFieldsFromZintType($event, mapIndex)">
          </zint-autocomplete>
        }
        @else {
          <span class="width-inherit text-break">{{mapping.zintProperty.displayName}}</span>
        }
      </div>

      <div class="col-3">
        @if($first){          
          <zint-autocomplete 
            [disabled]="!pubMethods.hasData(mapping.zintProperty)"
            [options]="crmProperties" 
            [displayProperty]="'label'" 
            [label]="formatCRMFieldLabel()"
            [subscriptKey]="'name'" 
            [matTooltip]="pubMethods.hasData(mapping.zintProperty) ? '': 'Select a ZINT Property first'"
            (optionSelected)="updateSelectedPropertyAtIndex(mapIndex,'crmField', $event)">
          </zint-autocomplete>
          @if (pubMethods.hasData(mapping.zintProperty)) {
             <div class="field-types-info">
            <small matTooltip="Available types: Text, Number, Date, User">Only showing fields compatible with ZINT field type:&nbsp;<strong>{{currentZintFieldType}}</strong></small>
            </div>

            <button class="rounded-btn-base rounded-btn-light py-0 px-1 refresh-fields-btn" matTooltip="Refresh fields" (click)="fetchCRMFields()">
                <i class="far fa-arrows-rotate fa-2xs text-vivid-blue"></i>
            </button>
          }        
        }
        @else {
        <span class="width-inherit text-break">{{mapping.crmField.label}}</span>
        }
      </div>

      <div class="col-3 text-center">
        @if ($first) {          
          <input type="checkbox" [(ngModel)]="mapping.overwrite" />        
        }
        @else {
        <span>{{mapping.overwrite?'Yes':'No'}}</span>
        }
      </div>
      <div class="col-3 text-center">  
        @if ($first) {       
         <button matTooltip="Add mapping" class="rounded-btn-base rounded-btn-vivid-outline btn-p-sm" (click)="confirmMappingAndAddMore(mapIndex)">
           <i class="fas fa-plus fa-xs" ></i>
         </button>
        }@else {

          <button matTooltip="Remove mapping" class="rounded-btn-base rounded-btn-red-outline btn-p-sm" (click)="removeMapping(mapIndex)">          
            <i class="fal fa-trash-can fa-xs"></i>
          </button>         
        }
      </div>       
    </div>
}
</div>

@if (showCustomConstantModal){

  <div class="modal fade" id="customZintConstantModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
      <div class="modal-content">  
        <div class="modal-header">
          <h6 class="mb-0">Add your Constant</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="position-relative">
            <input type="text" autofocus class="rounded-input-base full-width" [(ngModel)]="customZintConstant" (keyup.enter)="confirmCustomConstant()" placeholder="enter your constant"/>
            <button class="rounded-btn-base rounded-btn-dark-hover position-absolute btn-float" (click)="confirmCustomConstant()">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showOverwriteHelpModal) {
  <zint-modal [modalContent]="overwriteHelpModalContent" [modalConfig]="overwriteHelpModalConfig"></zint-modal>
}